let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b1CQa")).then(() => parcelRequire('fExJZ'));